import { render, staticRenderFns } from "./AdminPredefinedProductsScreen.vue?vue&type=template&id=e7b8a45c&scoped=true&"
import script from "./AdminPredefinedProductsScreen.vue?vue&type=script&lang=js&"
export * from "./AdminPredefinedProductsScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7b8a45c",
  null
  
)

export default component.exports